export default __webpack_public_path__ + "static/media/companies.403dc0cb.jpg";